import React, {
  FC, useEffect, useState,
} from 'react';
import { v4 as uuid } from 'uuid';
import {
  RowLeft,
} from '../Styles';
import OptionButton from '../components/Button/OptionButton';
import UserReply from '../components/Reply/UserReply';
import { getFoodifoxDataLazy } from '../../../../../lib/axios/FoodifoxDataAPI';
import RobotLoading from '../components/Loading/RobotLoading';
import Q12 from '../Q12';
import RobotReply from '../components/Reply/RobotReply';
import TempFieldUtils from '../../../../../lib/TempFieldUtils';
import { getWindowWidth, lang } from '../../../../../lib/utils/utils';
import LeftToRight from '../components/Animation/LeftToRight';
import { addSystemLog } from '../../../../../lib/SystemLogUtils';
import Q1 from '../Q1';
import Q22 from '../Q22';
import InterRegularText from '../../../../../components/Text/InterRegularText';
import InterSemiBoldText from '../../../../../components/Text/InterSemiBoldText';

const Q0: FC<Props> = ({
  addElement,
  cabId,
  setTargetPage,
  setIsToSelectLockerPage,
  deviceCode,
  enterPhoneNumber,
}) => {
  // 当前会话ID
  const [sessionId] = useState<string>(uuid());
  // 选项
  const options: {deliveryType: string; zhValue: string; enValue: string}[] = [
    { deliveryType: 'Food', zhValue: '外卖', enValue: 'Food' },
    { deliveryType: 'Parcel', zhValue: '快递', enValue: 'Parcel' },
  ];
  const [checkCabHasOrder] = getFoodifoxDataLazy<{ status: boolean }>('/fox3PDAi/checkHasOrder');

  const send = (deliveryType: string) => {
    const loadingFlowId = uuid();

    addElement(
      <RowLeft>
        <RobotLoading flowId={loadingFlowId} />
      </RowLeft>
    );
    checkCabHasOrder({
      param: {
        deliveryType,
        useCabId: cabId,
      },
      onCompleted({ status }) {
        setTimeout(() => {
          // 隐藏loading
          TempFieldUtils.aiFlowIds.push(loadingFlowId);
        }, 2000);
        setTimeout(() => {
          if (status) {
            if (deliveryType === 'Food') {
              addElement(
                <Q1
                  addElement={addElement}
                  cabId={cabId}
                  deviceCode={deviceCode}
                  setTargetPage={setTargetPage}
                  setIsToSelectLockerPage={setIsToSelectLockerPage}
                  enterPhoneNumber={enterPhoneNumber}
                  sessionId={sessionId}
                />
              );
            }
            else {
              addElement(
                <Q22
                  cabId={cabId}
                  addElement={addElement}
                  setTargetPage={setTargetPage}
                  deviceCode={deviceCode}
                  sessionId={sessionId}
                />
              );
            }
          }
          else {
            addElement(
              <Q12
                type={deliveryType === 'Food' ? 'Food' : 'Parcel'}
              />
            );
          }
        }, 2200);
      },
    });
  };

  useEffect(() => {
    // 流程ID，同一个流程下的按钮，只要点击了一次就加入到流程ID中，避免重复点击
    const flowId = uuid();
    const langZh = '您好，我是Rita，请问您是需要取外卖还是快递？';
    const langEn = 'Hello, I am Rita. Are you trying to collect your food or parcel delivery?';
    addElement(
      <LeftToRight flowId={flowId}>
        <RowLeft style={{ marginTop: 25 }}>
          <RobotReply
            style={{ maxWidth: 'unset', width: lang(getWindowWidth() * 0.57, getWindowWidth() * 0.7) }}
            langZh={langZh}
            langEn={(
              <InterRegularText fontSize={16} lineHeight={19}>
                Hello, I am Rita.
                <br />
                Are you trying to collect your <InterSemiBoldText isSpan={true} fontSize={16} lineHeight={19}>food</InterSemiBoldText> or <InterSemiBoldText isSpan={true} fontSize={16} lineHeight={19}>parcel</InterSemiBoldText> delivery?
              </InterRegularText>
            )}
          />
        </RowLeft>
      </LeftToRight>
    );

    // 机器人回复日志
    addSystemLog(cabId, deviceCode, '', 'Q0 - user: ' + enterPhoneNumber, sessionId);
    addSystemLog(cabId, deviceCode, '', 'Q0 - bot: ' + langEn, sessionId);

    setTimeout(() => {
      addElement(
        <LeftToRight flowId={flowId} speed={15}>
          {
            options.map(({ deliveryType, zhValue, enValue }, index) => {
                return (
                  <RowLeft key={index}>
                    <OptionButton
                      flowId={flowId}
                      langZh={zhValue}
                      langEn={enValue}
                      style={{ width: 110 }}
                      callback={() => {
                        // 用户回复日志
                        addSystemLog(cabId, deviceCode, deliveryType + '', 'Q0 - user: ' + enValue, sessionId);
                        addElement(
                          <UserReply
                            langZh={zhValue}
                            langEn={enValue}
                            style={{ width: 110, textAlign: 'center' }}
                          />
                        );
                        send(deliveryType);
                      }}
                    />
                  </RowLeft>
                );
            })
          }
        </LeftToRight>
      );
    }, 200);
  }, []);

  return (
    <></>
  );
};

export interface Props {
  addElement: (elements: any) => void;
  cabId: number;
  setTargetPage: (targetPage: string) => void;
  setIsToSelectLockerPage?: (isToLockerPage: boolean) => void;
  deviceCode: string;
  // 进入AI对话的用户手机号
  enterPhoneNumber: string;
}

export default Q0;
